import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

interface IDeleteConfirmationModalProps {
  isOpen: boolean
  itemName: string
  onToggleModal: () => void
  onConfirm: () => void
}

export default class DeleteConfirmationModal extends React.PureComponent<
  IDeleteConfirmationModalProps
> {
  constructor(props: IDeleteConfirmationModalProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <Modal
        centered
        isOpen={this.props.isOpen}
        toggle={this.props.onToggleModal}
      >
        <ModalHeader toggle={this.props.onToggleModal}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete{' '}
          <span className='font-weight-bold'>{this.props.itemName}</span>? This
          action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' outline onClick={this.props.onToggleModal}>
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button color='danger' onClick={this._confirmAction}>
            <FontAwesomeIcon icon={['fal', 'trash']} /> Confirm Delete
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _confirmAction() {
    this.props.onToggleModal()
    this.props.onConfirm()
  }
}
